<template>
  <div>
    <v-card mb-4 >
        <v-toolbar>
            <v-toolbar-title>Compliance</v-toolbar-title>
        </v-toolbar>
        <v-data-table
            :headers="headers"
            :items="getCases"
            :items-per-page="5"
            class="elevation-1"
            @click:row="showDetails"
        >
        <template v-slot:top>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
        <template>
            <v-card>
            <v-card-title >
                Case Details
            </v-card-title>
            <v-card-text>
            <v-container>
                <v-text-field
                readonly
                v-model="caseDetails.number"
                label="Case #"
                ></v-text-field>

                 <v-text-field
                 readonly
                 v-model="caseDetails.type"
                 label="Type"
                ></v-text-field>

                <v-textarea
                readonly
                v-model="caseDetails.description"
                label="Summary"
                ></v-textarea>

                <v-text-field
                readonly
                v-model="caseDetails.status"
                label="Status"
                ></v-text-field>
            
                <v-text-field
                readonly
                v-model="caseDetails.date"
                label="Date"
                ></v-text-field>
                <current-user-can  permission="viewCaseInfo">
                    <a :href="caseDetails.link">Link to Case</a>
                </current-user-can>
            </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn class="ma-4" color="primary" @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        </template>
        </v-dialog>
        </template> 
        </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrentUserCan from '../../lib/currentUserCan.vue';

export default {
  name: "caseList",
  props: { personId: [Number, String] ,
         },
  
  components: {
    CurrentUserCan
  },
data() {
        return {
            headers: [
            {
                text: 'Case #',
                align: 'start',
                sortable: false,
                value: 'number',
            },
            { text: 'Type', value: 'type' },
            { text: 'Pharmacist', value:'pharmacist'},
            ],
      caseItems: [],
      caseDetails:{},
      dialog: false,
      relatedCases: []
    };
    },
   component: {}, 
    props: {
      personId:String
    },
    methods: {
        showDetails(event) {
            this.caseDetails = {...event}
            this.dialog = true
        }
    },
    computed: {
       getCases() {
        const relatedCases =  this.$store.getters.getById(this.personId)?.practitioner?.cases || [] 
        if(relatedCases) {
          const pharmacist = this.$store.getters.getById(this.personId) 
          this.caseItems = []
          for(let i = 0; i < relatedCases.length; i++) {
            const status = relatedCases[i].status
            const date = (status==='closed')?relatedCases[i].closureDate:relatedCases[i].createddate
            let caseItemsObj = new Object()
            caseItemsObj.title = relatedCases[i].title
            caseItemsObj.description = relatedCases[i].description
            caseItemsObj.link = relatedCases[i]['@teamsLink']
            caseItemsObj.number = relatedCases[i].id
            caseItemsObj.type = relatedCases[i].type
            caseItemsObj.status = status
            caseItemsObj.pharmacist = pharmacist.fullname
            caseItemsObj.date = this.$moment(date).format('DD/MM/YY')
            this.caseItems.push(caseItemsObj)
          }
        }
        return this.caseItems
      }
    }
}
</script>